import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { setHidePatientName } from 'src/app/features/medical-record/store/medical-record.action';
import { MedicalRecordState } from 'src/app/features/medical-record/store/medical-record.state';
import { fullRoutes, LogoutMethod } from 'src/app/shared/enums/enums';
import { Alerts } from '../../../alerts/alert';
import { LoadingService } from '../../../loading/loading.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { getAuthStateSelect } from 'src/app/core/store/auth/auth.selector';
import { AuthState } from 'src/app/core/store/auth/auth.state';
import { getHidePatientName } from 'src/app/features/medical-record/store/medical-record.selector';
import { MedicalRecordService } from 'src/app/features/medical-record/services/medical-record.service';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent {

  @Input() name: string | undefined = '--';

  subscription: Subscription = new Subscription();
  email: string = '';
  hidePatientName: boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private store: Store<MedicalRecordState>,
    private loadingService: LoadingService,
    private alerts: Alerts,
    private medicalRecordService: MedicalRecordService
  ){
    this.subscription.add(this.store.select(getAuthStateSelect).subscribe((user: AuthState) => {
      if (user) {
        this.email = user.user?.email ?? '';
      }
    }));
    this.subscription.add(this.store.select(getHidePatientName).subscribe((value: any) => {
      this.hidePatientName = value;
    }));
  }

  hideDropDown = true;
  hideBackground = true;
  forgotPasswordError: boolean = false;
  forgotPasswordSuccess: boolean = false;

  onToggleDropdown() {
    this.hideDropDown = ! this.hideDropDown;
    this.hideBackground = ! this.hideBackground;
  }

  onClickOptions(event : MouseEvent) {
    event.stopPropagation()
  }

  logout(): void {
    this.performLogout();
  }

  performLogout(): void {
    firstValueFrom(this.medicalRecordService.isMedicalRecordOpen).then((isOpen) => {
      if (isOpen) {
        this.alerts.alertWithOneButton(
          'error',
          'Paciente em Atendimento',
          'Para sair do prontuário aberto você precisa "Finalizar o Atendimento" ou "Descartar o Atendimento".',
          'Entendido'
        );
        return;
      } else {
        this.authenticationService
          .logoutMethod(this.email, LogoutMethod.DEFAULT)
          .subscribe({
            next: () => {
              this.medicalRecordService.clearAllMedicalRecord();
              this.hidePatientName ? this.store.dispatch(setHidePatientName()) : null;
              this.authenticationService.logout();
              this.router.navigate([fullRoutes.LOGIN]);
            },
            error: (err) => {
              console.error(err);
            },
          });
      }
    }).catch((err) => {
      console.error(err);
    });
  }

  hideName(): void {
    this.store.dispatch(setHidePatientName())
  }

  sendEmail(): void {
    this.loadingService.show('general');
    this.authenticationService
      .sendEmailResetPassword(this.email)
      .subscribe({
        next: (value) => {
          this.forgotPasswordSuccess = true;
          this.forgotPasswordError = false;
          this.alerts.alertWithOneButton(
            'success',
            'E-mail enviado com sucesso',
            'Verifique a sua caixa de entrada',
            'Ok')
        },
        error: (err) => {
          this.forgotPasswordError = true;
          this.forgotPasswordSuccess = false;
          this.alerts.alertWithOneButton(
            'error',
            'Erro',
            'Não foi possível concluir a solicitação',
            'Ok'
          )
        },
      });
  }

  changePassword(): void {
    this.hideDropDown = ! this.hideDropDown;
    this.alerts
      .alertWithTwoButtons(
        'warning',
        'Alterar senha de acesso',
        'Confirma a solicitação de alterar a senha de acesso?'
      ).then(({ isConfirmed }) => {
        if (isConfirmed) {
          this.sendEmail();
        }
      });
  }
}
